import { jsx as v } from "react/jsx-runtime";
import { isCancel as D } from "axios";
import { useState as P, useEffect as U, useCallback as V } from "react";
import { AbortError as F } from "./index2.mjs";
import { AccessDenied as S } from "./index3.mjs";
import { BadRequest as x } from "./index4.mjs";
import { ConflictError as M } from "./index5.mjs";
import { FailedDependency as j } from "./index8.mjs";
import { InternalError as q } from "./index9.mjs";
import { LockedError as R } from "./index11.mjs";
import { NotFound as X } from "./index13.mjs";
import { PayloadTooLarge as G } from "./index14.mjs";
import { UnauthorizedResponse as J } from "./index15.mjs";
import { UnprocessableContentError as K } from "./index16.mjs";
import { checkAreThereFieldsErrors as Q } from "./index17.mjs";
const pe = ({
  httpClient: A,
  useRouter: O,
  useLocoTranslation: T,
  toast: s
}) => function({
  method: p,
  showFieldsErrorToast: a,
  stopErrorPropagation: b,
  badRequestHandler: f,
  unauthorizedResponseHandler: n,
  unprocessableContentHandler: t,
  internalErrorHandler: d,
  afterFetch: c,
  accessDeniedHandler: m,
  onErrorBeforeErrorHandlers: _,
  onNotFound: u,
  mock: i
}) {
  const r = O(), { t: o } = T(), [g, y] = P(0), [I, L] = P(!1);
  return U(() => L(!!g), [g]), { fetcher: V(
    async (...l) => {
      var h, w, E;
      y((e) => e + 1);
      const B = typeof process < "u" && ((h = process.env) == null ? void 0 : h.NODE_ENV) === "development" || typeof process < "u" && ((w = process.env) == null ? void 0 : w.NEXT_PUBLIC_APP_ENV) === "development" || typeof process < "u" && ((E = process.env) == null ? void 0 : E.APP_ENV) === "development";
      return (i && B ? new Promise((e, N) => {
        const C = i.delay ?? 3e3;
        setTimeout(() => {
          i.error ? N(i.error) : e(i.data);
        }, C);
      }) : A[p](
        l[0],
        l[1],
        l[2]
      ).then(async (e) => e && (c ? await c(e.data, e) : e.data))).catch(_).catch(async (e) => {
        if (typeof window < "u" && e instanceof X)
          u ? u(e) : process.env.NODE_ENV !== "development" && r.replace("/not-found");
        else if (typeof window < "u" && e instanceof S)
          m ? m(e) : r.push("/403");
        else if (typeof window < "u" && e instanceof J)
          n ? n(e) : window.location.assign(e.location);
        else if (typeof window < "u" && e instanceof q)
          d ? d(e) : s.error(o("core.error.internal_error_message"));
        else if (e instanceof x)
          a && e.errors && Q(e.errors.fields) && s.error(o("global.errors.fields_toast_message")), f ? f(e) : e.message && s.error(/* @__PURE__ */ v("p", { dangerouslySetInnerHTML: { __html: e.message } }));
        else if (e instanceof M)
          s.error(o("core.error.conflict_error_message"));
        else if (e instanceof K)
          t ? t(e) : s.error(e.message || o("core.error.conflict_error_message"));
        else if (e instanceof R)
          s.error(e.message);
        else if (e instanceof G)
          s.error(o("core.error.payload_to_large_error_message"));
        else if (e instanceof j)
          s.error(/* @__PURE__ */ v("p", { dangerouslySetInnerHTML: { __html: e.message } }));
        else {
          if (e instanceof F)
            throw e;
          !(D(e) || e.code === "ECONNABORTED") && s.error(o("global.error"));
        }
        if (!b)
          throw e;
      }).finally(() => y((e) => e - 1));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      p,
      c,
      r,
      n,
      a,
      f,
      t,
      m,
      _
    ]
  ), isFetching: I };
};
export {
  pe as getUseBaseFetch
};
